<template>
    <div>
        <osobe-navigation
            :id="osoba_id"
            :breadcrumbs="breadcrumbs"
        >
        </osobe-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Grupa statusa: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <osoba-grupa-statusa-forma
                    :disabled="false"
                    :id="id"
                    :modal="false"
                    :action="'edit'"
                    @returnData="setData"
                >
                </osoba-grupa-statusa-forma>
            </div>
        </div>
    </div>
</template>

<script>
import OsobeNavigation from "../OsobeNavigation";
import OsobaGrupaStatusaForma from "./OsobaGrupaStatusaForma";
export default {
    name: "OsobaGrupaStatusaEdit",
    components: { OsobaGrupaStatusaForma, OsobeNavigation },
    data(){
        return {
            breadcrumbs: [],
            id:this.$route.params.osoba_grupa_statusa_id,
            osoba_id: this.$route.params.osoba_id,
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/osobe/' + this.osoba_id + '/grupe-statusa',
                    name: 'Grupe statusa'
                },
                {
                    path: '/osobe/' + this.osoba_id + '/grupe-statusa/' + this.id,
                    name: 'Grupe statusa: ' + this.naziv
                },
                {
                    path: '/osobe/' + this.osoba_id + '/grupe-statusa/' + this.id + '/edit',
                    name: 'Uredi grupu statusa: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.grupa_statusa.naziv
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
